export const getCenterCoordinates = () => {
  const center: any = {
    lat: 38.1714552,
    lng: 140.8917196
  }
  return center
}
export const getDefaultZoomLevel = () => {
  const zoom: number = 14
  return zoom
}
